

const ReportsViewFilters = {
  default: [
  //     {
  //   label: "Status",
  //   key: "status",
  //   options: ["Completed", "In Progress"],
  // },

  // {
  //   label: "Prescription Type",
  //   key: "prescriptionType",
  //   options: ["Standard", "Emergency", "Non-Standard"],
  // }

  ],
  additional: [
  {
      label: "Date",
      key: "reportDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default ReportsViewFilters;
